<ul class="inspiration-items">
  <li *ngFor="let front of fronts" [class.active]="current.storage.frontId === front.id">
    <figure (click)="selectFront(front.id)">
      <span class="media">
        <img *ngIf="front.img !== ''" [src]="'assets/img/' + front.img" [alt]="front.label" />
        <span class="title-overlay">
   {{ front.label | translate }}
  </span>
        <span class="state">
          <svg class="icon-action-select-thumb" aria-hidden="true">
            <use
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xlink:href="assets/img/icons.svg#icon-action-select-thumb"></use>
          </svg>
        </span>
      </span>
    </figure>
  </li>
</ul>
